import { RadioButtonWithLabelGroupWidget, RadioButtonWithLabelOption } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { useFormikContext } from '../../../../FormikWrapperForStubbing';
import { settingsRadioButtonItemHeight } from '../../../../styles/CommonStyles';
import { SiteSettingsForServerAdminProps } from '../../ReactSiteSettingsForServerAdmin';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { StorageBytesField } from './StorageBytesField';

export const STORAGE_ENABLED_FIELD = 'settings.storageQuotaEnabled';
export type StorageSectionProps = SiteSettingsForServerAdminProps<'storageQuotaEnabled' | 'storageQuotaBytes'>

function getButtonsList(props: StorageSectionProps): RadioButtonWithLabelOption<boolean>[] {
  return [
    {
      value: false,
      label: Messages.serverLimit(),
      testId: 'storage-unlimited-radio-button'
    },
    {
      value: true,
      label: <StorageBytesField {...props}/>,
      testId: 'storage-enabled-radio-button'
    }
  ];
}

export function StorageSection(props: StorageSectionProps) {
  const formik = useFormikContext<StorageSectionProps>();

  const buttons = React.useMemo(() => getButtonsList(formik.values), [formik.values]);

  const index = buttons.findIndex(button => button.value === formik.values.settings.storageQuotaEnabled);

  const handleChange = React.useCallback((value: boolean) => formik.setFieldValue(STORAGE_ENABLED_FIELD, value), [formik]);

  return <SettingsSection title={Messages.storage()}
                          description={Messages.storageDetails()}>

    <RadioButtonWithLabelGroupWidget buttonList={buttons}
                                     aria-label={Messages.storage()}
                                     className={settingsRadioButtonItemHeight}
                                     checkedIndex={index}
                                     handleChange={handleChange}/>
  </SettingsSection>;
}

export const StorageSectionSpecs = componentRegistryEntry({
  name: 'StorageSection',
  component: StorageSection
});
